import {StyleSheet} from 'react-native';
import {scaleFonts} from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  scrollViewContent: {
    paddingVertical: 20,
  },
  contentContainer: {
    marginHorizontal: 20,
  },
  centerBox: {
    flex: 1,
  },
  profileImage: {
    width: scaleFonts(250),
    height: scaleFonts(250),
    borderWidth: 1,
    borderRadius: 1000,
  },
  shopperName: {
    marginTop: 15,
    marginBottom: 10,
  },
  metricsContainer: {
    marginBottom: 10,
    marginTop: 5,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  metricLabel: {
    marginBottom: 2,
  },
  metricValueRow: {
    justifyContent: 'center',
    flexDirection: 'row',
    gap: 5,
  },
  metricValueText: {},
  contactButtonWrapper: {
    flex: 1,
    width: '100%',
  },
  divider: {
    marginVertical: 20,
  },
  infoText1: {
    width: '60%',
    textAlign: 'center',
  },
  infoText2: {
    width: '70%',
    marginTop: 20,
    textAlign: 'center',
  },
  defaultBunchaBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: 1000,
  },
});
